


















import { Vue, Component, Watch } from 'vue-property-decorator'
import { EPLModule } from './store/eplmodule'
import { DictRequest, DictParam, DictOptions, DictFilter, LoginForm } from '@/types'
import { AxiosError } from 'axios'
const userInactiveTimeout = 60 * 2

@Component({
  name: 'App',
  components: {
    ShowError: () =>
      import(/* webpackChunkName: "ShowError" */ '@/components/ShowError.vue'),
    AppBar: () =>
      import(/* webpackChunkName: "AppBar" */ './components/AppBar.vue'),
    AppFooter: () =>
      import(/* webpackChunkName: "AppFooter" */ './components/AppFooter.vue')
  }
})
export default class App extends Vue {
  version = ''
  interval = 0
  authTimer = userInactiveTimeout
  idx = -1
  show = false
  showBar = false
  barKey = 0
  socket = {} as WebSocket
  colorNfc = 'primary'

  @Watch('$route')
  onRouteChange (to: any): void {
    EPLModule.setError('')
    if (to.path.toLowerCase() !== '/auth') {
      localStorage.setItem('lastPath', to.path)
    }
  }

  @Watch('isAuth')
  onAuthChange (): void {
    const path = this.$router.currentRoute.path
    if (this.isAuth) {
      this.showBar = true
      this.setAuthTimeout()
    } else {
      clearInterval(this.interval)
      this.showBar = false
      if (path.toLowerCase() !== '/auth') {
        setTimeout(() => {
          this.$router.push('/Auth')
        }, 500)
      }
    }
    this.barKey++
  }

  get isAuth (): boolean {
    return EPLModule.isAuth
  }

  get roleid (): number {
    return EPLModule.user.roleid
  }

  mounted () {
    this.initWebSocket()
    this.callbackActive()
    EPLModule.fetchUserInfo()
      .then(() => {
        // // для ускорения загрузки скачаем заголовки и листы самого большого справочника
        // const p = {} as DictParam
        // p.idx = EPLModule.DictIdx('EPL')
        // p.request = {} as DictRequest
        // p.request.options = { page: 1, itemsPerPage: 1 } as DictOptions
        // EPLModule.fetchDictData(p)
        // получим табельный номер
        if (EPLModule.user.driverid !== '') {
          const tn = {} as DictParam
          tn.idx = EPLModule.DictIdx('Drivers')
          tn.request = {} as DictRequest
          tn.request.options = { page: 1, itemsPerPage: 1 } as DictOptions
          tn.request.filter = []
          const d = {} as DictFilter
          d.field = 'uid'
          d.condition = EPLModule.user.driverid
          d.operator = '='
          d.combine = 'AND'
          tn.request.filter.push(d)
          EPLModule.fetchDictData(tn)
            .then(() => {
              if (EPLModule.dicts[tn.idx].rowsCount > 0) {
                EPLModule.setTabn(EPLModule.dicts[tn.idx].rows[0].tabn)
              }
            })
        }
        const path = localStorage.getItem('lastPath') as string
        this.show = true
        this.showBar = true
        this.setAuthTimeout()
        if (this.$router.currentRoute.path !== path) this.$router.push(path)
      })
      .catch((e: AxiosError) => {
        if (e.response && e.response.status === 401) {
          this.show = true
        }
      })
  }

  initWebSocket () {
    if (this.socket.readyState !== 1) {
      this.socket = new WebSocket('ws://127.0.0.1:9999/ws')
      this.socket.onmessage = (ev: MessageEvent<any>) => {
        // console.log('Route:', this.$router.currentRoute)
        // console.log('Recieve:', ev.data)
        if (ev.data === 'no readers') {
          this.colorNfc = ''
          return
        }
        if (ev.data === 'ready') {
          this.colorNfc = 'primary'
          return
        }
        if (this.$router.currentRoute.path === '/Auth') {
          if (localStorage.lastPath === undefined) localStorage.lastPath = '/'
          const form = {} as LoginForm
          form.username = 'loginbynfccardtag'
          form.passwd = ev.data
          EPLModule.fetchUserPost(form)
            .then(() => {
              // получим табельный номер
              if (EPLModule.user.driverid !== '') {
                const tn = {} as DictParam
                tn.idx = EPLModule.DictIdx('Drivers')
                tn.request = {} as DictRequest
                tn.request.options = { page: 1, itemsPerPage: 1 } as DictOptions
                tn.request.filter = []
                const d = {} as DictFilter
                d.field = 'uid'
                d.condition = EPLModule.user.driverid
                d.operator = '='
                d.combine = 'AND'
                tn.request.filter.push(d)
                EPLModule.fetchDictData(tn)
                  .then(() => {
                    if (EPLModule.dicts[tn.idx].rowsCount > 0) {
                      EPLModule.setTabn(EPLModule.dicts[tn.idx].rows[0].tabn)
                    }
                  })
              }
              this.$router.push(localStorage.lastPath)
            })
        }
        if (this.$router.currentRoute.path === '/dict/Users') {
          const idx = EPLModule.DictIdx('Users')
          if (EPLModule.dicts[idx].isShowForm) {
            EPLModule.dicts[idx].currentRow.cardid = ev.data
          }
        }
        if (this.$router.currentRoute.path === '/EPL') {
          EPLModule.dictFindField({ dict: 'Users', field: 'driverid', byfield: 'cardid', value: ev.data })
            .then((res: any) => {
              EPLModule.dictFindField({ dict: 'Drivers', field: 'fio', byfield: 'uid', value: res.data.str })
                .then((response: any) => {
                  EPLModule.setDriverFio(response.data.str)
                })
            })
        }
        this.colorNfc = 'error'
        setTimeout(() => { this.colorNfc = 'primary' }, 1000)
      }
    }
    this.socket.onopen = () => {
      // console.log('Successfully Connected')
      // this.socket.send('Hi From the Client!')
    }
    this.socket.onclose = event => {
      console.log('Socket Closed Connection: ', event)
      this.barKey++
      // this.socket.close()
    }
    this.socket.onerror = error => {
      console.log('Socket Error: ', error)
    }
  }

  private callbackActive (): void {
    if (this.roleid === 7) {
      this.authTimer = userInactiveTimeout
    } else {
      this.authTimer = 9999999999
    }
  }

  private setAuthTimeout (): void {
    this.callbackActive()
    window.addEventListener('mousemove', this.callbackActive)
    window.addEventListener('keypress', this.callbackActive)
    window.addEventListener('click', this.callbackActive)
    this.interval = setInterval(() => {
      if (this.authTimer === 0) {
        EPLModule.ClearAuth()
        this.authTimer = 9999999999
        return (this.authTimer = -1)
      }
      this.authTimer--
    }, 1000)
  }
}
